import { BrandMenu } from '@prismamedia/one-components';
import React, { FC, useEffect } from 'react';
import {
  useGlobalBrandKey,
  useGlobalNewslettersFilter,
} from 'utils/globalState';
import { BrandKey } from '__generated__/queries-newsletter';
import { useGetBrandKeys } from '../../apollo/queries/getBrandKeys.newsletter.graphql';

export const BrandSwitch: FC = () => {
  const { data } = useGetBrandKeys();
  const [brandKey, setBrandKey] = useGlobalBrandKey();
  const [, setNewslettersFilter] = useGlobalNewslettersFilter();

  useEffect(() => {
    if (!brandKey && data) {
      setBrandKey(data.getBrandKeys[0]);
      setNewslettersFilter([data.getBrandKeys[0]]);
    }
  }, [brandKey, data, setBrandKey, setNewslettersFilter]);

  return (
    <BrandMenu
      defaultLabel="Marque"
      items={
        data?.getBrandKeys?.map((brand) => ({
          id: brand,
          label: brand,
          selected: brandKey === brand,
        })) || []
      }
      onItemSelect={({ label }) => {
        setBrandKey(label as BrandKey);
        setNewslettersFilter([label]);
      }}
    />
  );
};
